module.exports = __webpack_public_path__ + "img/lojas.ba3db2b.svg";